"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _globalSpacing = require("./../globalSpacing");

var _makeStyles = _interopRequireDefault(require("./../makeStyles"));

var _excluded = ["children", "spacingOptions", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      gridTemplateColumns: 'minmax(0, 1fr)',
      '& .eds-tabs-container button:first-child': {
        marginLeft: 0
      }
    }
  };
});
/**
 * Layout model that provides a big picture of available options and allows users to quickly alternate views within the same context.
 * @done true
 * @updated v5.5.0
 * @template true
 * @versionAdded v5.5.0
 * @examples
 *  TabLayoutExample
 *  TabLayoutWithTable
 */

var TabLayout = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = useStyles();
  var children = props.children,
      spacingOptionsLocal = props.spacingOptions,
      className = props.className,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);

  var _useSpacing = (0, _globalSpacing.useSpacing)(spacingOptionsLocal),
      spacingStyles = _useSpacing[0],
      setSpacingOptions = _useSpacing[2];

  var _useState = (0, _react.useState)(null),
      localChildren = _useState[0],
      setLocalChildren = _useState[1];

  (0, _react.useEffect)(function () {
    setSpacingOptions(spacingOptionsLocal);
  }, [spacingOptionsLocal]); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    var childrenMap = _react.default.Children.map(children, function (child) {
      var localChild = child.type.muiName === 'Tabs' ? /*#__PURE__*/_react.default.cloneElement(child, {
        scrollButtonsOnMobile: true,
        scrollButtons: true
      }) : child;
      return localChild;
    });

    setLocalChildren(childrenMap);
  }, [children]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)(spacingStyles, className, classes.root),
    ref: ref
  }), localChildren);
});

TabLayout.muiName = 'TabLayout';
TabLayout.propTypes = {
  /**
   * A CSS class that will be applied to the parent `div`.
   */
  className: _propTypes.default.string,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Provides several attributes to control `TabLayout` spacing.
   *
   * Available options are:
   *
   * * `spacing` (string): **'standard'** | 'none' | \<object\>
   *      * Controls the padding of the `TabLayout` and grid gap between child elements
   *      * `standard`: The default spacing
   *      * `none`: Removes all spacing styles, allowing for complete style customization through the `classes` prop
   *      * `object`: Allows for more fine-grained spacing customization. See [container customization documentation](#/utilities/spacing#using-customizations-for-fine-grained-container-spacing-control)
   *        for more details.
   */
  spacingOptions: _propTypes.default.shape({
    spacing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
  })
};
var _default = TabLayout;
exports.default = _default;